'use client'

import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { useTranslations, useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { CarouselTest } from '@dustin-web/microsite-components/src/carousel-test/carousel'
import { ListItemRenderer } from '@dustin-web/product-components/src/product-list'

import { GET_CART_RECOMMENDATIONS } from '@dustin-web/microsite-data/src/graphql/product/get-cart-recommendations'
import {
  QueryCartPageRecommendationsArgs,
  CartPageRecommendations,
  ProductReference,
} from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import { useFeatureFlag } from 'packages/microsite-data/src/feature-flags/client'

interface CartRecommendationsQuery {
  cartPageRecommendations?: CartPageRecommendations
}

const CartRecommendations = () => {
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()
  const { enabled: isMaxFilterEnabled } = useFeatureFlag('ab-test-minicart-recommendation')

  const { cartItems } = useShoppingCart({ withRequiredEndUserInformation: true })
  const productIds = cartItems.map(p => p.productErpIdentifier)

  const getMaxPrice = () => {
    switch (sourcingCompany) {
      case 'SE':
        return 1000

      case 'DK':
        return 700

      case 'FI':
        return 94

      case 'NO':
        return 1100

      case 'NL':
        return 94

      default:
        return 1500
    }
  }

  const { data } = useGraphql<CartRecommendationsQuery, QueryCartPageRecommendationsArgs>(
    GET_CART_RECOMMENDATIONS,
    {
      variables: {
        productIds,
        noOfProducts: 12,
        minPrice: 0,
        maxPrice: isMaxFilterEnabled ? getMaxPrice() : undefined,
      },
    }
  )

  const products = data?.cartPageRecommendations?.productReferences || []

  return (
    <>
      {products.length > 0 && (
        <div className="c-zone u-overflow-hidden u-overflow-sm-visable">
          <div className="">
            <div className="row sm-gutters">
              <div className="col-12">
                <h3 className="u-mb-8 h3 d-flex u-color-black">
                  <span className={'u-mr-8'}>{isMaxFilterEnabled ? translate('Minicart_Recommendations_Header') : translate('Cart_Recommendations_Header')}</span>
                </h3>
                <CarouselTest
                  type="startpage"
                  dots={true}
                  dotMode="full-width"
                  partialVisible={true}
                  fullWidth={true}
                  colorTheme="gray"
                  list={products.map(
                    (p: ProductReference, key: number) =>
                      p.product && (
                        <ListItemRenderer
                          key={p.ticket + key}
                          imagePriority={false}
                          product={p.product}
                          ticket={p.ticket}
                          listType={'stripped'}
                          gallerySizeClasses={'slider-card u-px-8'}
                          digitalDataOrigin={'shoppingCartRecommendation'}
                          digitalIndex={key}
                        />
                      )
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CartRecommendations
